import { PdfRewardsByAcademicYearList } from 'components/pdfStudent';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetScienceRewards } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { scienceRewardsSelector } from '../../../selectors';
import PdfCommonDataEntityContainer from '../dataEntityContainers/common';
import { splitRewardsByAcademicYear } from '../utils/splitRewardsByAcademicYear';

const PdfScienceRewardContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const scienceRewards = useAppSelector(scienceRewardsSelector);

  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().scienceRewards });

  const hasData = scienceRewards.content.length > 0;

  const academicYearData = splitRewardsByAcademicYear(scienceRewards, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Награды" Icon={IconWidgetScienceRewards}>
      {hasData && <PdfRewardsByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfScienceRewardContainer;
